import AttachMoney from '@material-ui/icons/AttachMoney';

import List from './List';

export default {
  list: List,
  icon: AttachMoney,
};
